import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl, getCurrentDomain } from '../../utils/domainDetection';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website',
  jsonLd 
}) => {
  const location = useLocation();
  const domain = getCurrentDomain();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const defaultImage = `${domain.origin}/assets/images/preview.jpg`;

  const finalTitle = title ? `${title} | Parvej Hossain` : 'Parvej Hossain - Portfolio';
  const finalDescription = description || 'Parvej Hossain - GIS Enthusiast, Cartographer, Data Analyst, and Environmental Researcher';
  const finalImage = image ? (image.startsWith('http') ? image : `${domain.origin}${image}`) : defaultImage;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />

      {/* Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify({
            ...jsonLd,
            url: canonicalUrl
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
